import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const SEPTEMBER_2026_CAMPAIGN_END_DATE = d(2026, 11, 16, 12, 0);
